'use client';

import { Button } from '#/components/ui/button';
import {
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '#/components/ui/dialog';
import { deleteOrder_mutationFn } from '#/data/react-query/mutations/delete-order';
import {
  EthereumStakingOrderInfo,
  orderList_queryId,
} from '#/data/react-query/queries/order-list';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Translation } from 'intl-lib';
import { Loader2 } from 'lucide-react';
import { useRef } from 'react';
import { toast } from 'sonner';
import { OrderDisplayName } from '../../display/order-display-name';

interface Props {
  originalRow: EthereumStakingOrderInfo;
}
export function DialogContentImpl({ originalRow }: Props) {
  const queryClient = useQueryClient();

  const dialogCloseRef = useRef<HTMLButtonElement>(null); // 2. 创建 ref

  // const { trigger: triggerBatchCancelOrder, isMutating } =
  //   useEthereumStakingBatchCancelOrderMutation();

  const deleteOrder_mutation = useMutation({
    mutationFn: deleteOrder_mutationFn,
    onSuccess: async (data, variables) => {
      await queryClient.invalidateQueries({
        predicate: ({ queryKey }) => queryKey.includes(orderList_queryId),
      });
      dialogCloseRef.current?.click();
    },
  });

  async function onDeleteClick() {
    const promise = deleteOrder_mutation.mutateAsync({
      paramsSig: originalRow.paramsSig,
    });
    toast.promise(promise, {
      loading: 'Deleting order...',
      success: 'Deleted successfully',
      error: 'Failed to delete order',
    });
  }
  return (
    <>
      <DialogHeader>
        <DialogTitle>
          <Translation path="my_staking.delete_dialog.title" />{' '}
          <OrderDisplayName item={originalRow} />
        </DialogTitle>
        <DialogDescription>
          <Translation path="my_staking.delete_dialog.description" />
        </DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <DialogClose ref={dialogCloseRef} className="hidden" />
        <DialogClose asChild>
          <Button variant="secondary">
            <Translation path="Application.Dialog.CancelButtonLabel" />
          </Button>
        </DialogClose>
        <Button
          type="button"
          variant="primary"
          disabled={deleteOrder_mutation.isPending}
          onClick={onDeleteClick}
        >
          {deleteOrder_mutation.isPending && (
            <Loader2 className="h-4 w-4 animate-spin" />
          )}
          <Translation path="my_staking.delete_dialog.trigger" />
        </Button>
      </DialogFooter>
    </>
  );
}
export function DeleteOrderDialogContent({ originalRow }: Props) {
  return (
    <DialogContent className="sm:max-w-sm">
      <DialogContentImpl originalRow={originalRow} />
    </DialogContent>
  );
}
